import { useEffect, useState } from "react";
import { Ticket, MapPin, CalendarBlank } from "@phosphor-icons/react";
import { Reveal, Overline } from "./Reveal";
import { api } from "@/lib/api";

const fmt = (d) => {
  if (!d) return "Date TBA";
  try {
    return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return "Date TBA"; }
};

export const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.events().then((r) => setEvents(r.data.events || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <section id="events" className="relative py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal><Overline>Event Calendar</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-heading font-black text-3xl md:text-5xl mt-4 max-w-3xl">
            Upcoming <span className="gold-text">Epic</span> Experiences
          </h2>
          <p className="text-zinc-400 mt-4 max-w-xl">Grab your tickets on Eventbrite and pull up to the vibe.</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {loading && Array(4).fill(0).map((_, i) => (
            <div key={i} className="h-80 rounded-lg bg-white/5 animate-pulse" />
          ))}
          {!loading && events.map((e, i) => (
            <Reveal key={e.id} delay={i * 0.06}>
              <div data-testid={`event-card-${i}`} className="group bg-[#121212] border border-white/10 rounded-lg overflow-hidden hover-lift h-full flex flex-col">
                <div className="relative h-44 overflow-hidden">
                  <img src={e.image} alt={e.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <span className="absolute top-3 left-3 bg-black/70 backdrop-blur text-[#D4AF37] text-[11px] font-semibold uppercase tracking-wide px-3 py-1 rounded-full">{e.category}</span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="font-heading font-bold text-lg leading-snug">{e.name}</h3>
                  <div className="mt-3 space-y-1.5 text-sm text-zinc-400">
                    <p className="flex items-center gap-2"><CalendarBlank size={15} className="text-[#D4AF37]" /> {fmt(e.date)}</p>
                    <p className="flex items-center gap-2"><MapPin size={15} className="text-[#D4AF37]" /> {e.venue}</p>
                  </div>
                  <a data-testid={`event-tickets-${i}`} href={e.url} target="_blank" rel="noreferrer"
                    className="mt-5 inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black font-heading font-bold rounded-full py-2.5 hover:bg-[#F3E5AB] transition-colors">
                    <Ticket size={16} weight="fill" /> Buy Tickets
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
